module.exports = __webpack_public_path__ + "img/07.c9df6127.png";